import { default as WJElement } from '../wje-element/element.js';
import CardControls from './card-controls.element.js';

// export * from "./card-controls.element.js";
export default CardControls;

WJElement.define('wje-card-controls', CardControls);
